import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { useCasesData } from '@/data/mock';
import { Shield, HeartHandshake, Stethoscope, Brain, ArrowRight } from 'lucide-react';

const iconMap = {
  Shield,
  HeartHandshake,
  Stethoscope,
  Brain,
};

export const UseCasesSection = () => {
  return (
    <section id="use-cases" className="relative py-24 bg-slate-950">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-slate-900/30 to-transparent" />
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-emerald-500/10 text-emerald-400 text-sm font-medium rounded-full mb-4">
            Use Cases
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            Built for critical roles
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            Industry-specific simulations that test what actually matters
          </p>
        </div>
        
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {useCasesData.map((useCase, index) => {
            const Icon = iconMap[useCase.icon];
            return (
              <Card
                key={index}
                className="bg-slate-900/50 border-slate-800/50 hover:border-emerald-500/30 transition-all duration-300 group cursor-pointer"
              >
                <CardContent className="p-6">
                  <div className="w-12 h-12 rounded-xl bg-emerald-500/10 flex items-center justify-center mb-4 group-hover:bg-emerald-500/20 transition-colors">
                    <Icon size={24} className="text-emerald-400" />
                  </div>
                  <h3 className="text-lg font-semibold text-white mb-2">{useCase.title}</h3>
                  <p className="text-slate-400 text-sm mb-4">{useCase.description}</p>
                  <div className="flex items-center text-emerald-400 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                    Learn more <ArrowRight size={14} className="ml-1" />
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
